import Node from './Node';
import TextType from './TextType';

abstract class ValueNode<T> extends Node {

	public constructor (private value: T) {
		super();
	}

	public getValue () {
		return this.value;
	}

	public abstract toText (textType?: TextType): string;

	public abstract normalized (): ValueNode<T>;
}

export default ValueNode;


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/ValueNode.ts